import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0b8edd36&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8edd36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/luxury_dreams_production/releases/20261103171319/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8edd36')) {
      api.createRecord('0b8edd36', component.options)
    } else {
      api.reload('0b8edd36', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0b8edd36&scoped=true", function () {
      api.rerender('0b8edd36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/booking/index.vue"
export default component.exports